export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["给"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收到"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过滤器"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刷新"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代码"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卖方"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您给"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您收到"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限制"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有交易"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["制造者"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["好处"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日期"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["暂无报价"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["别担心——您可以更改筛选条件或创建自己的报价。"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["尝试调整筛选条件或稍后再查看。"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的报价"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["描述"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不在限制范围内"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资金不足。请至少充值"])}
}